/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useState
} from 'react';
import {SCIPendingSettings} from '@ion/core/src/types/entities';
import {BulkSCIStyleProps} from './BulkSCISettings';
import {SCIWifiTab} from './SCIWifiTab';

export interface BulkSCIWifiTab extends BulkSCIStyleProps {
  classes: {
    [key: string]: string;
  };
  wifiNetworks: SCIPendingSettings;
  onSetWifiNetworks: (wifiNetworks: SCIPendingSettings) => void;
};

/**
 * Edit Wifi related settings for SCI Devices in bulk
 */
export function BulkSCIWifiTab({
  classes,
  wifiNetworks,
  onSetWifiNetworks,
  isBulkAction = false
}: BulkSCIWifiTab) {
  const [newWifiNetwork, setNewWifiNetwork] = useState({ssid: '', pass: ''});
  const [isRemoveWifi, setIsRemoveWifi]     = useState<string>(null);

  useEffect(() => {
    if (isRemoveWifi) {
      const wifiNetworksData = wifiNetworks?.wifiNetworks?.networks;
      const copyWifiNetworksData = wifiNetworksData;
      for (let i = 0; i < copyWifiNetworksData.length; i++) {
        if (copyWifiNetworksData[i].ssid === isRemoveWifi) {
          copyWifiNetworksData.splice(i, 1);
          break;
        }
      }
      onSetWifiNetworks({
        ...wifiNetworks,
        wifiNetworks : {...wifiNetworks.wifiNetworks, networks: [...copyWifiNetworksData]}
      });
      setIsRemoveWifi(null);
    }
  }, [isRemoveWifi]);

  const handleNetworkChange = useCallback(function({target: {name, value}}: ChangeEvent<HTMLInputElement>) {
    setNewWifiNetwork({...newWifiNetwork, [name]: value});
  }, [newWifiNetwork]);

  const onAddWifiNetwork = useCallback(() => {
    if (newWifiNetwork.pass !== '' || newWifiNetwork.ssid !== '') {
      const {networks} = wifiNetworks?.wifiNetworks || {};
      const updated = [...networks];
      updated.push(newWifiNetwork);
      onSetWifiNetworks({...wifiNetworks, wifiNetworks: {...wifiNetworks.wifiNetworks, networks: [...updated]}});
      setNewWifiNetwork({...newWifiNetwork, ssid: '', pass: ''});
    }
  }, [newWifiNetwork, wifiNetworks]);

  function onRemoveWifiNetwork(removeRow: string) {
    setIsRemoveWifi(removeRow);
  };

  return (
    <SCIWifiTab wifiNetworks={wifiNetworks}
      classes={classes}
      handleNetworkChange={handleNetworkChange}
      noUpdate={false}
      onAddWifiNetwork={onAddWifiNetwork}
      onRemoveWifiNetwork={onRemoveWifiNetwork}
      sciPendingSettingData={{}}
      newWifiNetwork={newWifiNetwork}
      isBulkAction={isBulkAction} />
  );
};

export default BulkSCIWifiTab;
